<template>
    <AssistantLauncher :available="available" :open="drawerOpen" @toggle="toggle" />
    <Transition name="assistant-drawer">
        <AssistantDrawer v-if="drawerOpen" :open="drawerOpen" :context="activeContext"
            :messages="transcriptMessages" :queued-messages="queuedMessages"
            :processing="processing" :polling="polling" :sources="sources"
            :error="error"
            :skill-state="skillState" :maturity="maturity"
            :assistant-state="assistantState" :presentation="assistantPresentation"
            :activity="currentActivity" :failure="failure" :composer-locked="composerLocked"
            :conversations="conversations" :conversations-loading="conversationsLoading"
            :history-open="historyOpen" :current-title="currentTitle" :current-session-id="sessionId"
            @close="close" @send="sendMessage" @retry="retryInvocation"
            @toggle-history="historyOpen = !historyOpen"
            @new-conversation="newConversation" @load-conversation="loadConversation"
            @rename-conversation="renameConversation" @archive-conversation="archiveConversation"
            @search-history="searchConversations" />
    </Transition>
</template>

<script>
import AssistantDrawer from './AssistantDrawer.vue'
import AssistantLauncher from './AssistantLauncher.vue'
import { useAiAssistantContext } from '@/composables/useAiAssistantContext'

export default {
    name: 'GlobalAiAssistant',
    components: { AssistantDrawer, AssistantLauncher },
    setup() {
        return useAiAssistantContext()
    },
}
</script>

<style>
.assistant-drawer-enter-active,
.assistant-drawer-leave-active { transition: transform 0.28s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.22s ease; }
.assistant-drawer-enter-from,
.assistant-drawer-leave-to { transform: translateX(2rem); opacity: 0; }
</style>
